import { render, staticRenderFns } from "./provincialRelationship.vue?vue&type=template&id=733a466e&scoped=true"
import script from "./provincialRelationship.vue?vue&type=script&lang=js"
export * from "./provincialRelationship.vue?vue&type=script&lang=js"
import style0 from "./provincialRelationship.vue?vue&type=style&index=0&id=733a466e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a466e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733a466e')) {
      api.createRecord('733a466e', component.options)
    } else {
      api.reload('733a466e', component.options)
    }
    module.hot.accept("./provincialRelationship.vue?vue&type=template&id=733a466e&scoped=true", function () {
      api.rerender('733a466e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessPlatform/provincialRelationship.vue"
export default component.exports